<script>
    import {tick} from "svelte";
    import {PAGE_ID, router, navigateTo} from "../../stores/router";
    import {getNullCompany, companyAsObject, I_COMPANY, COMPANY_LABELS} from "../../../../../../lib/datatypes";
    import {addCompany, selectCompany} from "../../stores/misc";
    import CompanyChooser from "../CompanyChooser.svelte";

    const getEmptyCompany = () => {
        let result = getNullCompany();
        result = companyAsObject(result);
        return result;
    };
    let add_company = getEmptyCompany();

    const doAddCompany = async () => {
        let result = await addCompany(add_company);
        add_company = getEmptyCompany();
        await tick();

        selectCompany(result[I_COMPANY.ID]);
        navigateTo(PAGE_ID.VIEW_COMPANY, PAGE_ID.COMPANIES);
    };

    const onBackClick = () => {
        if($router.context.previous_page_id !== null) {
            navigateTo($router.context.previous_page_id);
        }
        else {
            navigateTo(PAGE_ID.COMPANIES);
        }
        add_company = getEmptyCompany();
    };
</script>


<div class="absolute top-16 right-0 bottom-0 left-0 overflow-y-auto" class:hidden={$router.current_page !== PAGE_ID.ADD_COMPANY}>

    <!-- Header -->
    <div class="px-4 sm:px-6 lg:px-8">

        <!--<Breadcrumbs></Breadcrumbs>-->

        <div class="h-16 flex items-center justify-between">
            <a on:click|preventDefault={onBackClick} href="/" class="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700">
                <svg class="-ml-1 mr-1 h-5 w-5 flex-shrink-0 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z" clip-rule="evenodd" />
                </svg>
                Back
            </a>
        </div>

    </div>

    <div class="px-4 sm:px-6 lg:px-8">

        <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">Add Company</h2>

        <div class="my-4 border-l-4 border-yellow-400 bg-yellow-50 p-4">
            <div class="flex">
                <div class="flex-shrink-0">
                    <svg class="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
                    </svg>
                </div>
                <div class="ml-3">
                    <p class="mb-4 text-sm text-yellow-700">
                        Use the searchbox below to check to see if the company you're adding is already in the database!
                    </p>
                </div>
            </div>
            <div>
                <CompanyChooser
                        type="box"
                        current_search_str=""
                        minimise_box_without_search={true}
                        allow_adding_company={false}></CompanyChooser>
            </div>
        </div>

        <div class="mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-6 sm:gap-x-6">
            <div class="sm:col-span-3">
                <label for="company-name" class="block text-sm font-medium text-gray-900">Name</label>
                <input bind:value="{add_company.name}" type="text" name="company-name" id="company-name" autocomplete="company-name" class="mt-1 block w-full rounded-md border-gray-300 text-gray-900 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
            </div>
        </div>

        <div class="mt-4">
            <label for="description" class="block text-sm font-medium text-gray-900">Description</label>
            <div class="mt-1">
                    <textarea bind:value={add_company.description}
                              id="description" name="description" rows="4"
                              class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"></textarea>
            </div>
            <p class="mt-3 text-sm italic text-gray-500">({@html COMPANY_LABELS.DESCRIPTION})</p>
        </div>


        <div class="flex justify-end pt-8">
            <button on:click={onBackClick}
                    type="button"
                    class="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-900 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >Cancel</button>
            <button on:click={doAddCompany}
                    type="submit"
                    class="ml-3 inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            >Save</button>
        </div>

    </div>

</div>


<style></style>